import Products from 'merchandise-lib/constants/Product';
import { DECEMBER_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { ENTERPRISE } from '../../constants/Tabs';
import { usePageParams } from '../../../hooks/usePageParams';
import { useProductPromotionIds } from '../pricing/useGrowthPurchaseOptions';
const STARTER_PRODUCT_API_NAME = Products.CRM_SUITE_STARTER_BUNDLE;

// Pages where the banner should be displayed
const INCLUDED_PAGES = ['SUITE', 'MARKETING', 'SALES', 'SERVICE', 'DATA', 'CMS', 'CONTENT', 'CRM'];
export const useStarterPromoDecember2025Banner = ({
  screen
}) => {
  const {
    tab
  } = usePageParams();
  const {
    promotionIds,
    loading: promotionIdsLoading,
    error: promotionIdsError
  } = useProductPromotionIds({
    productApiName: STARTER_PRODUCT_API_NAME
  });
  const eligibleForPromotion = DECEMBER_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS.some(key => promotionIds.includes(key));

  // Convert screen to uppercase to handle both v1 (lowercase) and v2 (uppercase) values
  const normalizedScreen = screen.toUpperCase();
  const isValidScreenForPromo = INCLUDED_PAGES.includes(normalizedScreen) && tab !== ENTERPRISE;
  const shouldShowBanner = Boolean(!promotionIdsLoading && eligibleForPromotion && isValidScreenForPromo && !promotionIdsError);
  return {
    shouldShowBanner,
    loading: promotionIdsLoading,
    error: promotionIdsError
  };
};